import { render, staticRenderFns } from "./PagarFatura.vue?vue&type=template&id=ffbe1952"
import script from "./PagarFatura.vue?vue&type=script&lang=js"
export * from "./PagarFatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports